<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-8">
          <edit-profile-form :user='this.userData'>
          </edit-profile-form>
        </div>
        <!-- <div class="col-md-4">
          <user-card>
          </user-card>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
  import EditProfileForm from './UserProfile/EditProfileForm.vue'
  import UserCard from './UserProfile/UserCard.vue'

  export default {
    components: {
      EditProfileForm,
      UserCard
    },
    data () {
      return {
        userData: {
          company: '',
          username: '',
          email: '',
          firstName: '',
          lastName: '',
          address: '',
          city: '',
          country: '',
          postalCode: '',
          aboutMe: ``
        },
        currentUser:'',
      }
    },
    created(){
      this.getUser()
    },
    methods:{
      async getUser() {
        this.currentUser = await this.$auth.getUser()
        this.userData= {
          company: this.currentUser.department,
          username: this.currentUser.email,
          email: this.currentUser.email,
          name: this.currentUser.name,
        }
        console.log(this.userData)
      }
    },
  }

</script>
<style>

</style>
